import "./OrderLines.css"

export default function OrderLines({ children, ariaLabelledBy, ariaLabel, listTag = true }) {
	const Tag = listTag ? "ol" : "div"

	return (
		<Tag aria-labelledby={ariaLabelledBy} aria-label={ariaLabel} className="color-bg-secondary-100 pl-lg-6 p-3 orderLines">
			{children}
		</Tag>
	)
}
